module.exports = __webpack_public_path__ + "img/forestDetailTree.c899b795.svg";